import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

import { px, rem, Theme } from '../../theme';
import { Paragraph } from '../Paragraph';

export const StyledCard = styled(Card, {
    shouldForwardProp: property =>
        typeof property === 'string' && !property.startsWith('$'),
})<{ $isMBTOptimization?: boolean }>`
    ${({
        theme,
        $isMBTOptimization,
    }: {
        theme: Theme;
        $isMBTOptimization?: boolean;
    }) => `
        padding: ${theme.tggSpacing(rem(3.2), 13)};
        margin: ${theme.tggSpacing([rem(3), rem(0.2), 0], [12, 1, 0])};
        border: none;
        border-radius: ${theme.tggSpacing(rem(1.6), 6.5)};

        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing(rem(4), 16)};
            margin: ${!$isMBTOptimization && theme.tggSpacing([rem(3), 0, 0], [12, 0, 0])};
        }

        ${theme.breakpoints.down(468)} {
            padding: ${!$isMBTOptimization && theme.tggSpacing(rem(2), 8)};
        }

        ${theme.breakpoints.down(405)} {
            padding: ${!$isMBTOptimization && theme.tggSpacing(rem(1.5), 6)};
        }

        ${
            $isMBTOptimization &&
            `
                padding: ${theme.tggSpacing([rem(3), rem(1)], [12, 4])};
                margin: ${theme.tggSpacing(0, 0)};
            `
        };
	`}
`;

export const StyledButtonContainer = styled('div')<{
    isrejoin?: boolean;
    $isMBTOptimization?: boolean;
}>`
    ${({
        theme,
        $isMBTOptimization,
        isrejoin,
    }: {
        theme: Theme;
        isrejoin?: boolean;
        $isMBTOptimization?: boolean;
    }) => `
        display: flex;
        flex-direction: ${isrejoin ? 'column' : 'row'};
        gap: 1rem;
        justify-content: center;
        max-width: ${isrejoin && '50%'};
        margin: ${
            isrejoin
                ? theme.tggSpacing([rem(3), 'auto'], [12, 'auto'])
                : `${theme.tggSpacing([px(20), 0, 0, 0], [5, 0, 0, 0])};`
        };

        ${theme.breakpoints.up('desktop')} {
            margin-top: ${$isMBTOptimization ? theme.tggSpacing(rem(1.4), 5.5) : theme.tggSpacing(rem(3), 12)};
        }
        ${theme.breakpoints.down('desktop')} {
            max-width: ${isrejoin && '100%'};
        }

        ${
            $isMBTOptimization &&
            `
                flex-direction: column;
                max-width: ${theme.tggSpacing(rem(38), 152)};
                margin: ${theme.tggSpacing([rem(1.4), 'auto', 0], [5.5, 'auto', 0])};
            `
        };
        `}
`;

export const StyledFixedProductOptions = styled('div')`
    ${({
        theme,
        $isMBTCardsOptimizationEnabled,
    }: {
        theme: Theme;
        $isMBTCardsOptimizationEnabled: any;
    }) => `
         display: flex;
        gap: ${$isMBTCardsOptimizationEnabled ? theme.tggSpacing(rem(1), 4) : theme.tggSpacing(rem(0.3), 1)};
        justify-content: ${$isMBTCardsOptimizationEnabled && 'center'};

        & > article {
            display: flex;
            flex: 1;
            flex-flow: column;
            min-width: ${$isMBTCardsOptimizationEnabled && theme.tggSpacing(0, 0)};
        }

        && footer {
            display: flex;
            flex-flow: column;
            align-items: end;
            margin-top: auto;
        }

        ${theme.breakpoints.up('desktop')} {
            gap: ${$isMBTCardsOptimizationEnabled ? theme.tggSpacing(rem(1), 4) : theme.tggSpacing(rem(1.3), 5)};
        }

        button.MuiButton-textPrimary {
            margin-top: ${theme.tggSpacing(rem(1), 4)};
        }
	`}
`;

export const StyledParagraph = styled(Paragraph, {
    shouldForwardProp: property =>
        typeof property === 'string' && !property.startsWith('$'),
})<{ $isMBTOptimizationV2orV3?: boolean; $isMBTOptimization?: boolean }>`
    && {
        ${({ theme }) => `
            margin-top: ${theme.tggSpacing(rem(3), 12)};
            margin-bottom: ${theme.tggSpacing(rem(4), 16)};
	    `}

        text-align: center;

        ${({ $isMBTOptimization, theme }) =>
            $isMBTOptimization && theme.typography.text_12}

        ${({ $isMBTOptimization, theme }) =>
            $isMBTOptimization &&
            `
                padding-inline: ${theme.tggSpacing(rem(3), 12)};
            `}

        ${({ $isMBTOptimizationV2orV3, theme }) =>
            $isMBTOptimizationV2orV3 &&
            `
                margin-top: ${theme.tggSpacing(rem(3), 12)};
                flex-direction: column;
                max-width: ${theme.tggSpacing(rem(38), 152)};
                margin-inline: ${theme.tggSpacing('auto', 'auto')};
            `}

        ${({ $isMBTOptimization, $isMBTOptimizationV2orV3, theme }) =>
            $isMBTOptimization &&
            !$isMBTOptimizationV2orV3 &&
            `
                && {
                    margin-top: ${theme.tggSpacing(rem(2), 8)};
                    margin-bottom: ${theme.tggSpacing(rem(1.4), 5.5)};
                }
            `}

        ${({ theme }) => theme.breakpoints.up('desktop')} {
            ${({ $isMBTOptimization, theme }) =>
                $isMBTOptimization && theme.typography.text_14};
        }
    }
`;
